import { _fetch as fetchSecure } from '@hobs/utils/fetch';

import {
  list,
  tree,
  GET,
  CREATE,
  UPDATE,
  DELETE,
  CLEAR
} from '@hobs/constants/annex';
import { actionCreator } from './utils/utils';

export function getAnnexes() {
  return dispatch => {
    dispatch(request());

    return fetchSecure('Exercises/Annexes')
      .then(response => {
        if (response) {
          dispatch(success(response.payload));

          return { success: true };
        } else {
          dispatch(failure(response.toString()));

          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: list.REQUEST };
  }
  function success(annexes) {
    return { type: list.SUCCESS, annexes };
  }
  function failure(error) {
    return { type: list.FAILURE, error };
  }
}

export function getAnnexesTree() {
  return dispatch => {
    dispatch(request());

    return fetchSecure('AnnexesTree')
      .then(response => {
        if (response) {
          dispatch(success(response.payload));

          return { success: true };
        } else {
          dispatch(failure(response.toString()));

          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: tree.REQUEST };
  }
  function success(annexes) {
    return { type: tree.SUCCESS, annexes };
  }
  function failure(error) {
    return { type: tree.FAILURE, error };
  }
}

export const getAnnex = annexId =>
  actionCreator(`Exercises/Annexes/${annexId}`, GET);

export const createAnnex = body =>
  actionCreator('Exercises/Annexes', CREATE, {
    body: body,
    method: 'POST'
  });

export const updateAnnex = (annexId, body) =>
  actionCreator(`Exercises/Annexes/${annexId}`, UPDATE, {
    body: body,
    method: 'PUT'
  });

export const deleteAnnex = annexId =>
  actionCreator(`Exercises/Annexes/${annexId}`, DELETE, {
    method: 'DELETE'
  });

export function clearAnnex() {
  return dispatch => {
    dispatch({ type: CLEAR.SUCCESS });
  };
}
